import React from 'react';
import classNames from 'classnames';

import styles from './FormInput.module.scss';

interface FormInputProps {
  label: string;
  id: string;
  type?: string;
  value: string | number | readonly string[] | undefined;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string | null;
}

export function FormInput({
  label,
  id,
  type = 'text',
  value,
  onChange,
  required = false,
  disabled = false,
  error = null,
  placeholder = '',
}: FormInputProps): React.JSX.Element {
  return (
    <div
      className={classNames(styles.formInput, {
        [styles.formInputError]: error,
      })}
    >
      <label htmlFor={id} className={styles.label}>
        {label}
        {required && <span className={styles.required}>*</span>}
      </label>
      <input
        type={type}
        id={id}
        className={styles.input}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        required={required}
        disabled={disabled}
      />
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}
